const getApiErrorMessage = (error: any): string => {
  const isText = (text: any): boolean => typeof text === 'string' && !!text.length;
  if (isText(error)) return error;
  if (isText(error?.message)) {
    return `${error.message} ${isText(error.payload?.detail) ? `- ${error.payload.detail}` : ''} ${
      isText(error.payload?.tracer) ? `[${error.payload.tracer}]` : ''
    }`.trim();
  }
  return 'Unknown error';
};

export default getApiErrorMessage;
